import fetch from '../utils/fetch'
import qs from 'qs'

//创建商户
export const fetchCreateBusiness = (body) =>
  fetch(`company`, {
    method: 'post',
    body,
  })
//商户列表
export const fetchBusinessList = ({ companyName = '', pageNum, pageSize }) =>
  fetch(
    `company/list?companyName=${companyName}&pageNum=${pageNum}&pageSize=${pageSize}`
  )
//编辑商户
export const fetchEditBusiness = (body) =>
  fetch(`company`, {
    method: 'put',
    body,
  })
//未绑定微仓列表
export const fetchUnbindList = () => fetch(`capsule/unBindList`)
//绑定设备
export const fetchBindEquipment = (body) =>
  fetch(`company/bind`, {
    method: 'post',
    body,
  })
//查询商户下设备列表
export const fetchBusinessEquipmentList = ({ companyId, pageNum, pageSize }) =>
  fetch(
    `company/capsuleList?companyId=${companyId}&pageNum=${pageNum}&pageSize=${pageSize}`
  )
//解除绑定
export const fetchUnbind = (body) =>
  fetch(`company/unBindCapsule`, {
    method: 'put',
    body,
  })
//解除安装
export const fetchUninstall = (body) =>
  fetch(`company/unInstallCapsule`, {
    method: 'put',
    body,
  })

//运营商列表
export const fetchOperaList = (data) => {
  return fetch(`/operate/list?${qs.stringify(data)}`)
}

//增加运营商
export const addOpera = (body) => {
  return fetch(`/operate`, {
    method: 'post',
    body,
  })
}

//编辑运营商
export const editOpera = (body) => {
  return fetch(`/operate`, {
    method: 'put',
    body,
  })
}

//分账公司列表
export const shareCompanyList = (params) => {
  return fetch(`/try/share/company/list`, {
    method: 'get',
    params,
  })
}

//分账公司详情
export const shareCompanyDetail = (params) => {
  return fetch(`/try/share/list`, {
    method: 'get',
    params,
  })
}

//提现记录列表
export const shareRecordList = (params) => {
  return fetch(`/try/share/withdrawal/list`, {
    method: 'get',
    params,
  })
}

//绑定运营商
export const bindBusiness = (body) => {
  return fetch(`/operate/capsule/bind`, {
    method: 'put',
    body,
  })
}

//查看点位
export const getPointList = (params) => {
  return fetch(`/operate/point/list`, {
    method: 'get',
    params,
  })
}

//解绑设备
export const uninstall = (id) => {
  return fetch(`/operate/point/uninstall/${id}`, {
    method: 'put',
  })
}

export const bindposition = (data) => {
  return fetch(`/operate/point/bind/capsule`, {
    method: 'post',
    data,
  })
}

export const unbindposition = (tryPointId) => {
  return fetch(`/operate/point/unbind/${tryPointId}`, {
    method: 'put',
  })
}

export const setPro = (data) => {
  return fetch(`/operate/point/proportion`, {
    method: 'put',
    data,
  })
}

export const getBrandList = (params) => {
  return fetch(`/operate/point/brand/list`, {
    method: 'get',
    params,
  })
}

//查看投放商品详情
export const fetchGoodsDetails = (params) => {
  return fetch(`/operate/point/capsule/details`, {
    params,
  })
}
